import React from 'react';
import { Button, Box, Typography, Card, CardMedia, useTheme } from '@mui/material';

const ServiceCard = ({ 
    name, 
    addon,
    onServiceSelected,
    image, 
    description, 
    price, 
    packages = [], 
    minWidth = { xs: 200, sm: 240, md: 260 }, 
    maxWidth = { xs: 1, sm: 320, md: 340 }, 
    height = '100%' 
}) => {
    const theme = useTheme();

    // Format price to currency
    const formatPrice = (price) => {
        if (!price) return 'Price not available';
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(price);
    };

    const handleAddToCart = () => {
        console.log("handleAddToCart", name);
        onServiceSelected(addon);
    }

    return (
        <Card sx={{
            p: { xs: 2, sm: 3 },
            borderRadius: theme.shape.borderRadius * 2,
            boxShadow: 0,
            border: `1px solid ${theme.palette.divider}`,
            minWidth,
            maxWidth,
            height,
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            bgcolor: 'background.paper',
        }} aria-label="Service details">
            <CardMedia
                component="img"
                image={image || '/default-service.jpg'}
                alt={name}
                sx={{ width: '100%', height: 140, objectFit: 'cover', borderRadius: theme.shape.borderRadius, mb: 1 }}
            />
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, wordBreak: 'break-word' }}>
                {name}
            </Typography>
            
            {description && (
                <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    sx={{ 
                        mb: 1,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    {description}
                </Typography>
            )}
            <Box sx={{ display: 'flex', gap: 2, marginTop: 2 }}>
                <Button 
                variant="contained" 
                color="primary" 
                onClick={handleAddToCart}
                fullWidth
                >
                Add to Cart
                </Button>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mt: 'auto' }}>
                {price && (
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 0.5, 
                            px: 1, 
                            py: 0.5, 
                            border: `1px solid ${theme.palette.divider}`, 
                            borderRadius: theme.shape.borderRadius, 
                            fontSize: 14 
                        }}
                    >
                        💰 {formatPrice(price)}
                    </Box>
                )}
                {packages && packages.length > 0 && (
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 0.5, 
                            px: 1, 
                            py: 0.5, 
                            border: `1px solid ${theme.palette.divider}`, 
                            borderRadius: theme.shape.borderRadius, 
                            fontSize: 14 
                        }}
                    >
                        📦 {packages.length} {packages.length === 1 ? 'Package' : 'Packages'}
                    </Box>
                )}
            </Box>
        </Card>
    );
};

export default ServiceCard; 